import { FilterSchema } from "./BreakdownByEntities";

export const getWindowSize = (): {
  innerWidth: number;
  innerHeight: number;
} => {
  const { innerWidth, innerHeight } = window;

  return { innerWidth, innerHeight };
};

export const generateFilter = (id: string): FilterSchema => {
  if (id === "overview") {
    return {
      $schema: "https://powerbi.com/product/schema#basic",
      target: {
        table: "pbi_view_client_hierarchy",
        column: "pbi_subsidiary_id",
      },
      operator: "NotIn",
      values: [1],
      filterType: 1,
    };
  }

  return {
    $schema: "https://powerbi.com/product/schema#basic",
    target: {
      table: "pbi_view_client_hierarchy",
      column: "pbi_subsidiary_id",
    },
    operator: "In",
    values: [id],
    filterType: 1,
  };
};
